import { BsCloudMoonFill } from 'react-icons/bs';

import { Grid, Switch, Typography } from '@mui/material';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
const DND = () => {
    const dispatch = useDispatch();
    //state Theme
    const [sdm, setSdm] = useState(
        JSON.parse(localStorage.getItem('themeDark'))
    );
    const themeToggle = () => {
        JSON.parse(localStorage.getItem('themeDark'))
            ? localStorage.setItem('themeDark', JSON.stringify(false))
            : localStorage.setItem('themeDark', JSON.stringify(true));
        setSdm(JSON.parse(localStorage.getItem('themeDark')));

        dispatch({
            type: 'theme',
        });
    };
    return (
        <>
            <Grid item>
                <Grid
                    item
                    container
                    alignItems='center'
                    justifyContent='space-between'>
                    <Grid item>
                        <Typography variant='subtitle1'>
                            Dark Mode <BsCloudMoonFill />
                        </Typography>
                    </Grid>
                    <Grid item>
                        <Switch
                            color='primary'
                            onChange={themeToggle}
                            checked={sdm}
                            // onChange={(e) =>
                            //     setTheme(dispatch(toggleTheme(theme)))
                            // }
                            name='sdm'
                            size='small'
                        />
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
};

export default DND;
